import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-our-team-card',
  templateUrl: './our-team-card.component.html',
  styleUrls: ['./our-team-card.component.scss']
})
export class OurTeamCardComponent implements OnInit {
  @Input() teamCard: any;
  constructor() { }

  ngOnInit(): void {
  }

}
